import React from "react";

import ActionBar from "../components/ActionBar";
import Loader from "../components/Loader";
import * as API from "../util/api";
import * as Util from "../util/util";
import VLComponent from "./VLComponent";

class AccountScreen extends VLComponent {

    constructor() {
        super();
        this.state = {loaded: false, events: []};
    }

    componentDidMount() {
        API.POST("account/getInfo", {}, result => {
            Util.handleLogout(result);
            if (result.success) {
                this.setState(result.result);
                this.setState({loaded: true});
            }
        });
    }

    render() {
        return (
            <div>
                <ActionBar title="Account Info"/>
                <div id="content" style={{
                    display: this.state.loaded ? "block" : "none",
                    width: "100%",
                    justifyContent: "center",
                    marginTop: 16,
                    maxHeight: "calc(100vh - 92px)",
                    overflowY: "auto",
                    textAlign: "center"
                }}>

                    <img style={{width: "50%"}} src={this.state.app_image}/>

                    <h2>{this.state.app_name}</h2>
                    <p>User: {this.state.username}</p>
                    <p>Access Level: {Util.getAccessLevel(this.state.access_level)}</p>
                    <p>User Email: <a href={"mailto:" + this.state.user_email}>{this.state.user_email}</a></p>
                    <p style={{paddingTop: "8px"}}>Technical Support: <a href={"mailto:support@vision-link.co.uk"}>support@vision-link.co.uk</a></p>
                    {/* <p>Credit: £{this.state.account_credit}</p>
                    <p>Image Cost: £{this.state.image_cost}</p>
                    <p>Enhanced Polling Cost: £{this.state.enhanced_cost}</p>
                    <p>Global Image Request Cost: £{this.state.global_cost}</p> */}
                </div>
                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }


}

export default AccountScreen;
